import React from "react";
import { Field } from "formik";
import {InputContainer} from "styles/components/AnimatedInput";


const EmailFieldInput = (props) => {
  const blurHandler = (evt) => {
    props?.calllBack && props?.calllBack(evt.target.value)
  }

  
  return (
    <Field name={props?.name}>
      {({ field, meta, form }) => {
        return (
          <InputContainer>
            <div className="input-container">
              <input
                // className={`${meta.touched && meta.error ? "error" : ""}`}
                name={field.name}
                // placeholder={props?.placeholder}
                type={props?.type}
                value={field.value || ""}
                maxLength={props?.maxLength}
                disabled={props?.disabled}
                onKeyUp={(evt) => {              
                  const removeSpace = evt.target.value.replace(/ /g, "")
                  form.setFieldValue(props?.name, removeSpace)
                  props?.calllBack && props?.calllBack(evt.target.value,"keyDown")
                }}
                onBlurCapture={blurHandler}
                onChange={() => {}}
                {...field}
              />            
              <label className={field.value && 'filled'} htmlFor={props?.name}>
                {props?.placeholder}
              </label>
              {meta.touched && meta.error && props?.showErrorMessages && (
                <p name={props?.name + "Error"} className="error-message">{meta.error}</p>
              )}

              
            </div>
          </InputContainer>
        );
      }}
    </Field>
  );
}
export default EmailFieldInput;